import LoadingDialog from "../shared/components/modal/LoadingDialog";
import Header, { HeaderBackground,HeaderRight,HeaderLeft} from '../shared/components/Header';
import * as Form from "../shared/components/form";
import * as Label from "../shared/components/labels";
import Progress from "../shared/containers/Other/Progress";
import TaskSuccess from "../shared/components/TaskSuccess";
import Videoplayer from "../shared/components/Videoplayer";
import { CheckComponent } from "../shared/components";
import Recorder from "../shared/components/Recorder";
import { SuccessAvatar } from "../shared/components";
// import ExitAlert from "../shared/components/";
import { WCTaskPaper, WCRiddlePaper, ProgressPaper } from "../shared/components/WCPaper";
import ProgressStrength from "../shared/components/ProgressStrength";
import MemberProgress from "../shared/components/List/MemberProgress";
import RateBox from "../shared/components/RateBox";
import ButtonGroup from "../shared/components/ButtonGroup";

export {
    LoadingDialog,
    Header,
    HeaderBackground,
    Form,
    Label,
    Progress,
    TaskSuccess,
    Videoplayer,
    CheckComponent,
    Recorder,
    SuccessAvatar,
    // ExitAlert,
    WCTaskPaper,
    WCRiddlePaper,
    ProgressPaper,
    ProgressStrength,
    MemberProgress,
    RateBox,
    HeaderRight,
    HeaderLeft,
    ButtonGroup
    
};